import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { CenterFilter } from 'src/app/model/center-filter';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { PracticeRegionFilter } from 'src/app/model/practice-region-filter';
import { ServiceFilter } from 'src/app/model/service-filter';
import { SpecialityFilter } from 'src/app/model/speciality-filter';
import { AdmissionService } from 'src/app/services/admission.service';
import { AuthService } from 'src/app/services/auth.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-admission-integrated-filter',
  templateUrl: './admission-integrated-filter.component.html',
  styleUrls: ['./admission-integrated-filter.component.css']
})
export class AdmissionIntegratedFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteSpecialities: FilterCompleteService<SpecialityFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private admissionService: AdmissionService,
    private authService: AuthService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Protocol: [""],
      Center: [""],
      InSector: [""],
      Service: [""],
      Specialty: [""],
      PracticeRegion: [""],
      Physician: [""],
      Patient: [null],
      OrderByPatient: [false],
      NoViewAdmissionControled: [false],
      ViewPreAdmission: [false],
      ViewCancel: [false],
    });

    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Physician
    );
    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      [],
      this.form.controls.Center
    );
    this.filterCompleteSpecialities =
      new FilterCompleteService<SpecialityFilter>(
        [],
        this.form.controls.Specialty
      );
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.PracticeRegion
      );
  }

  get filteredPhysiciansOptions() {
    return this.filterCompletePhysicians
      ? this.filterCompletePhysicians.filteredOptions
      : [];
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }
  get filteredSpecialitiesOptions() {
    return this.filterCompleteSpecialities
      ? this.filterCompleteSpecialities.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("DateFrom");
    requiredTags.push("DateTo");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters("AdmissionFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "AdmissionFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    const serviceId = this.form.controls.Service.value
      ? this.form.controls.Service.value.Id
      : null;

    let sectorId: number = null;
    if (this.form.controls.InSector.value) {
      sectorId = this.authService.getSectorId();
    }


    const noViewAdmissionControled = this.form.controls.NoViewAdmissionControled
      .value
      ? this.form.controls.NoViewAdmissionControled.value
      : false;

    let admissionControled = null;

    if (noViewAdmissionControled) {
      admissionControled = false;
    }

    return await this.admissionService.getAdmissionSearchItemsAdmited(
      <Date>this.form.controls.DateFrom.value,
      <Date>this.form.controls.DateTo.value,
      this.form.controls.Protocol.value,
      this.authService.getCompanyIds(),
      serviceId,
      this.form.controls.OrderByPatient.value
        ? this.form.controls.OrderByPatient.value
        : false,
      this.form.controls.ViewPreAdmission.value
        ? this.form.controls.ViewPreAdmission.value
        : false,
      true,
      this.form.controls.ViewCancel.value
        ? this.form.controls.ViewCancel.value
        : false,
      this.form.controls.Patient.value
        ? this.form.controls.Patient.value.Id
        : null,
      this.form.controls.PracticeRegion.value
        ? this.form.controls.PracticeRegion.value.Id
        : null,
      this.form.controls.Specialty.value
        ? this.form.controls.Specialty.value.Id
        : null,
      this.form.controls.Center.value
        ? this.form.controls.Center.value.Id
        : null,
      sectorId,
      this.form.controls.Physician.value
        ? this.form.controls.Physician.value.Id
        : null,
      admissionControled
    );
  }

  ngOnInit() {
    this.filterService.getServicesFilter().then((services) => {
      this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
        services,
        this.form.controls.Service
      );
    });

    this.filterService.getPracticesRegionFilter().then((practicesRegion) => {
      this.filterCompletePracticesRegion =
        new FilterCompleteService<PracticeRegionFilter>(
          practicesRegion,
          this.form.controls.PracticeRegion
        );
    });

    this.filterService.getSpecialtiesFilter().then((specialities) => {
      this.filterCompleteSpecialities =
        new FilterCompleteService<SpecialityFilter>(
          specialities,
          this.form.controls.Specialty
        );
    });

    this.filterService.getPhysiciansFilter().then((physicians) => {
      this.filterCompletePhysicians =
        new FilterCompleteService<PhysicianFilter>(
          physicians,
          this.form.controls.Physician
        );
    });

    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
        centers,
        this.form.controls.Center
      );
    });
  }
}
